var React = require('react');

function Lcl (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M5 8h22v16H5zM5 15.5h22v2H5zM15 8v16h2V8z"}));
}

Lcl.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Lcl;

Lcl.default = Lcl;
